import Footer from "Component/Footer/Footer";
import Header from "Component/Header/Header";
import React, { useState, useEffect } from "react";
import { Accordion, Col, Container, FormGroup, Row } from "react-bootstrap";
import { Input } from "reactstrap";
import AuCard from "./MuseumCard";
import { getALLMuseums } from "store/actions";
import { useDispatch, useSelector } from "react-redux";
import { Oval } from 'react-loader-spinner'
export default function MuseumsView() {
  const [jquryacc, setjquryacc] = useState(true)
  const dispatch = useDispatch()
  const [topMuseums, setTopMuseums] = useState([])
  const { musuems, loading } = useSelector((selector) => selector?.museums)
  const [data2, setData2] = useState([])
  const [data, setData] = useState([])
  const [search, setSearch] = useState("")
  useEffect(() => {
    dispatch(getALLMuseums())
  }, [])
  useEffect(() => {
    setData2(musuems)
  }, [musuems])




  const setSearchFunction = (value) => {
    setSearch(value)
  }

  useEffect(() => {
    setData(data2?.filter((item) => {
      return search.toLowerCase() === '' ? item : item?.museumName?.toLowerCase().includes(search.toLowerCase())
    }))
  }, [search])
  useEffect(() => {
    if (search === '') {
      setData(data2)
    }
  }, [data2, search])

  return (
    <>
      {loading &&
        <div className='loaderBoxMiane'>
          <Oval
            height={80}
            width={80}
            color="#6C63FF"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#6C63FF"
            strokeWidth={2}
            strokeWidthSecondary={2}
          />
        </div>
      }
      <Header />
      <div className="container-fluid profileBox dashboardprofile">
        <Row>
          <Col lg={12}>
            <h1>MUSEUMS</h1>
          </Col>
        </Row>
      </div>
      {/* <section>
        <Container>
          <Col lg={12}>
            <Row className="justify-content-center">
              <Col lg={7}>
                <div className="catesearch position-relative">
                  <Input
                    className="categorySearch"
                    placeholder="Search..."
                    onChange={(e) => setSearchFunction(e.target.value)}
                  />
                  <button>
                    <i className="fa-light fa-magnifying-glass"></i>
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Container>
      </section> */}
      <section className="py-5">
        <Container>

          <Row>
            {data && data?.map((idx) => {
              return (
                <Col key={idx?._id} className="mb-5" lg={3}>
                  <AuCard data={idx} key={idx?.name} />
                </Col>
              )
            })}
          </Row>
        </Container>
      </section>
      <Footer />
    </>
  )
}